var exports = {
  "kL": "xfd349460--56b5b5--container",
  "AZ": "xfd349460--56b5b5--room-count",
  "Lr": "xfd349460--56b5b5--house-name",
  "p_": "xfd349460--56b5b5--finish-date",
  "Wc": "xfd349460--56b5b5--area",
  "q9": "xfd349460--56b5b5--price",
  "j8": "xfd349460--56b5b5--layout-image",
};

module.exports = exports;
